import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Avatar } from "@/components/common";
import { api } from "@/lib/api";

export function CreatorPicker({ selected, onChange, multiple, testid = "creator-picker" }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/creators-lite", { params: { q } }).then((r) => setResults(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  const ids = selected.map((s) => s.user_id);
  const toggle = (c) => {
    if (ids.includes(c.user_id)) onChange(selected.filter((s) => s.user_id !== c.user_id));
    else onChange(multiple ? [...selected, c] : [c]);
  };
  return (
    <div className="space-y-2" data-testid={testid}>
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {selected.map((s) => (
            <span key={s.user_id} className="inline-flex items-center gap-1.5 rounded-full border border-primary/30 bg-primary/10 text-primary text-xs pl-3 pr-1.5 py-1" data-testid={`${testid}-selected-${s.user_id}`}>
              {s.full_name}<button type="button" onClick={() => toggle(s)} className="hover:text-foreground"><X className="h-3.5 w-3.5" /></button>
            </span>
          ))}
        </div>
      )}
      {(multiple || selected.length === 0) && (
        <>
          <div className="relative">
            <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search approved creators" className="pl-9 rounded-xl bg-background" data-testid={`${testid}-search`} />
          </div>
          <div className="max-h-48 overflow-y-auto rounded-xl border border-border divide-y divide-border/60">
            {results.length === 0 ? <p className="text-xs text-muted-foreground p-3">No approved creators found.</p> : results.map((c) => (
              <button type="button" key={c.user_id} onClick={() => toggle(c)} data-testid={`${testid}-option-${c.user_id}`}
                className={`w-full flex items-center gap-3 p-2.5 text-left text-sm hover:bg-secondary/50 ${ids.includes(c.user_id) ? "bg-primary/5" : ""}`}>
                <Avatar src={c.profile_picture} name={c.full_name} className="h-7 w-7" />
                <span className="flex-1 truncate">{c.full_name} <span className="text-muted-foreground">@{c.instagram_username}</span></span>
                <span className="text-[11px] text-muted-foreground">{c.category_name}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
